/**
 * fruit-ninja-without-score: cyan ring = logical hit radius (center-anchored), under PNG fruit.
 * Disable: `?debugFruit=0` on tv.html or `localStorage.setItem('debugFruit','0')`.
 */
export function shouldDrawRemoteFruitDebugRing(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if (window.localStorage.getItem('debugFruit') === '0') return false;
  } catch {
    /* ignore */
  }
  const q = new URLSearchParams(window.location.search);
  if (q.get('debugFruit') === '0') return false;
  if (q.get('debugFruit') === '1') return true;
  return false;
}

export function drawImageCover(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  dx: number,
  dy: number,
  dWidth: number,
  dHeight: number,
): void {
  const iw = img.naturalWidth;
  const ih = img.naturalHeight;
  if (iw <= 0 || ih <= 0) return;
  const scale = Math.max(dWidth / iw, dHeight / ih);
  const w = iw * scale;
  const h = ih * scale;
  const x = dx + (dWidth - w) / 2;
  const y = dy + (dHeight - h) / 2;
  ctx.drawImage(img, x, y, w, h);
}
